module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/operations.c87f648f.svg";